export const replaceAll = (str: string, find: string, replace: string) => {
  const escapeRegExp = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
};
